import { Injectable, inject, signal } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { ReservationsService } from '../reservations.service';
import { CalculatedVehicleCategoryModel, ReservationCalculatedDataQueryModel } from '../reservations.model';

/**
 * Loads the car groups (with their bookable extras) available for a set of booking inputs from the
 * booking service and owns that result as a signal. Provided per dialog instance; the caller decides
 * when to (re)load (signature/skip logic stays with the form it depends on).
 */
@Injectable()
export class ReservationCalculatedDataLoader {
  private _reservationsService = inject(ReservationsService);

  readonly vehicleCategories = signal<CalculatedVehicleCategoryModel[]>([]);

  reset(): void {
    this.vehicleCategories.set([]);
  }

  load(inputs: ReservationCalculatedDataQueryModel): Observable<CalculatedVehicleCategoryModel[]> {
    return this._reservationsService.getCalculatedData(inputs).pipe(
      tap((data) => this.vehicleCategories.set(data.vehicleCategories)),
      map((data) => data.vehicleCategories)
    );
  }
}
